import {Typography} from '@hconnect/uikit'
import {Grid, LinearProgress} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {Widget} from '../../../Molecules/Widget/Widget'

import {ScheduleNewRMCDelivery} from './ScheduleNewRMCDelivery'

interface OrderIntakeRMCWidgetProps {
  isFetchingRMCOrderIntakeRoles?: boolean
  isPermissionToOrderRMCForSelectedCustomer?: boolean
  hasRMCBusinessLine?: boolean
}

export const OrderIntakeRMCWidget = ({
  isFetchingRMCOrderIntakeRoles,
  isPermissionToOrderRMCForSelectedCustomer,
  hasRMCBusinessLine
}: OrderIntakeRMCWidgetProps) => {
  const {t} = useTranslation()

  // No permission state
  if (!isPermissionToOrderRMCForSelectedCustomer && !isFetchingRMCOrderIntakeRoles) {
    return (
      <Grid item xs={12} sm={6}>
        <Widget
          title={t('orderIntake.rmc.widget.title')}
          data-test-id="widget-rmc-order-intake-no-permission"
        >
          <Typography variant="caption" color="error">
            {t('orderIntake.rmc.widget.notAllowed')}
          </Typography>
        </Widget>
      </Grid>
    )
  }

  // Loading state
  if (isFetchingRMCOrderIntakeRoles) {
    return (
      <Grid item xs={12} md={12}>
        <Widget
          title={t('orderIntake.rmc.widget.title')}
          data-test-id="widget-rmc-order-intake-loading"
        >
          <LinearProgress data-test-id="widget-rmc-order-intake-loader" />
          <Typography variant="caption">{t('orderIntake.rmc.widget.loading')}</Typography>
        </Widget>
      </Grid>
    )
  }

  // Main widget state - show RMC delivery option if customer has RMC business line
  if (hasRMCBusinessLine && !isFetchingRMCOrderIntakeRoles) {
    return (
      <Grid item xs={12} md={12}>
        <Widget
          title={t('orderIntake.rmc.widget.mainTitle')}
          subTitle={t('orderIntake.rmc.widget.mainSubtitle')}
          data-test-id="widget-schedule-new-rmc-delivery"
        >
          <ScheduleNewRMCDelivery />
        </Widget>
      </Grid>
    )
  }

  return null
}
